export enum CarrierAccessorialRequestStatusEnum {
  New = 1,
  Pending = 2,
  Pending_AdditionalInfoRequired = 3,
  Denied = 4,
  Approved = 5,
}
